
import {defineComponent} from "vue";
import {HtmlContentRestDtoModel} from "@/models/api/pharma-cms-content-block/HtmlContentRestDtoModel";
import {CbStructureMixin} from "@/components/layouts/content-pages/wysiwyg/structures/CbStructureMixin";
import {NormalContentBlockRestService} from "@/services/rest/cms-content-block/NormalContentBlockRestService";
import {FindNormalContentBlockPayload} from "@/models/payload/FindNormalContentBlockPayload";
import {CreateNormalContentBlockPayload} from "@/models/payload/CreateNormalContentBlockPayload";
import {SaveNormalContentBlockPayload} from "@/models/payload/SaveNormalContentBlockPayload";
import BaseSpinner from "@/components/UI/Bootstrap/BaseSpinner.vue";
import InputHtml from "@/components/UI/InputHtml.vue";

export default defineComponent({
  name: "CbHtml",
  components: {InputHtml, BaseSpinner},
  extends: CbStructureMixin,
  data: () => ({
    contentBlock: HtmlContentRestDtoModel.createWithDefaults(),
  }),
  methods: {
    async find(payload: FindNormalContentBlockPayload): Promise<HtmlContentRestDtoModel> {
      return await NormalContentBlockRestService.getInstance().findHtml(payload.type, payload.id);
    },
    async create(payload: CreateNormalContentBlockPayload): Promise<string> {
      return await NormalContentBlockRestService.getInstance().createHtml(payload.cb as HtmlContentRestDtoModel, payload.type);
    },
    async save(payload: SaveNormalContentBlockPayload): Promise<void> {
      await NormalContentBlockRestService.getInstance().saveHtml(payload.cb as HtmlContentRestDtoModel, payload.type, payload.id);
    },
    getDefaultCbModel(): HtmlContentRestDtoModel {
      return HtmlContentRestDtoModel.createWithDefaults();
    },
  }
});
